<template>
    <mailchimp-subscribe
      url="https://immunizationacademy.us4.list-manage.com/subscribe/post-json"
      user-id="3326383d63a10decbcafdab83"
      list-id="ca3c085a44"
      @success="onSuccess"
    >
      <template v-slot="{ subscribe, setEmail, error, success, loading }">
        <form @submit.prevent="subscribe">
          <div class="flex pt-6">
            <input @input="setEmail($event.target.value)" id="subscribe" type="email" class="flex-1 p-2 bg-white rounded-l-lg focus:outline-none focus:shadow-outline text-black" :placeholder="$t('footer.subscribe_placeholder')"/>
            <button class="bg-action hover:bg-action-dark text-black rounded-r-lg px-3 text-white focus:outline-none" type="submit" :disabled="loading">
              <loading-icon v-if="loading"></loading-icon>
              <template v-if="!loading">
                {{$t('footer.subscribe')}}
              </template>
            </button>
          </div>
          <p class="text-red-500 text-xs italic pt-3 pb-1" v-if="error" v-html="error"></p>
        </form>
      </template>
    </mailchimp-subscribe>
</template>

<script>
import MailchimpSubscribe from 'vue-mailchimp-subscribe';
import LoadingIndicator from './LoadingIndicator';

export default {
  components: {
    MailchimpSubscribe,
    LoadingIndicator,
  },
  methods: {
    onSuccess() {
      Snackbar.show({
        text: this.$t('footer.subscribe_success_message'),
        actionText: this.$t('dismiss'),
      });
    },
  },
}
</script>